import {
    scriptNoTempAreaCharts,
    scriptNoTempColumnCharts,
    scriptNoTempGaugeCharts,
    scriptNoTempPieCharts
} from "./chartScripts/scriptsNoTempCharts";
import {
    scriptTempBubbleCharts,
    scriptTempCharts,
    scriptTempHeatMapCharts,
    scriptTempScatterCharts
} from "./chartScripts/scriptTempCharts";
import CustomHighCharts from "./customCharts/CustomHighCharts";
import React from "react";
import CustomTableCharts from "./customCharts/CustomTableCharts";
import uuid from "react-uuid";
import Highcharts from 'highcharts';
import HC_exporting from "highcharts/modules/exporting";
import HC_exportingOff from "highcharts/modules/offline-exporting"
import CustomNoData from "./customCharts/CustomNoData";
import { DPE, GES } from "./DPE/DpeEnergyTertiary";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { NumericFormat } from 'react-number-format';

HC_exportingOff(Highcharts);
HC_exporting(Highcharts);

/**
 * * Fonction permettant de traiter toutes les types de charts en fonction de leurs categories
 */
const isObjEmpty = (obj) => {
    for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
}

const valueIcon = (icon) => {
    let color = "#ffffff";
    if (icon == 1)
        color = "#91C73C";
    else if (icon == 2)
        color = "#FF763A";
    else if (icon == 3)
        color = "#C53F3F";
    return color;
}

export const getChartCategoryScript = (data, title, category, type, stacking, id, simplecard) => {

    let script = null;
    let scriptTables = null;
    let displayChart = [];
    let displayTables = [];
    let customTable;
    let customChart;
    let customDPE = null;
    let customGES = null;

    let tooltip = "Pas de description disponible pour ce graphique";
    let nodata = false;

    //si data affiché les données de script sinon renvoyer un script avec le titre et le message
    if (!data || isObjEmpty(data) === true) {
        let NoData = (<CustomNoData chartTitle={title} />);
        //displayChart.push(NoData);
        nodata = true;
    } else {
        if (data["tooltip"] && data["tooltip"] !== "") {
            tooltip = data["tooltip"];
        }
        if (category === 0) {
            if (type === "gauge") {
                script = scriptNoTempGaugeCharts(data);
            } else if (type === "pie") {
                script = scriptNoTempPieCharts(data);
            }
            else if (type === "tab" || type === "palmares") {
                if (isObjEmpty(data) === false && data.lines) {
                    data.lines.map((line) => {
                        line.id = uuid();
                    });
                    data.headers.map(head => {
                        //head.flex = (100/data.headers.length);
                        head.headerAlign = 'center';
                        head.name = head.headerName;
                        //head.selector = row => row[head.field] ? (head.type === 'number' ? Number(row[head.field]) : row[head.field]) : '';
                        head.selector = row => row[head.field] || '';
                        head.sortable = true;
                        head.wrap = true;
                        head.right = head.type === 'number' ? true : false
                        if (head.type === 'palmares') {
                            head.width = '107px';
                        }
                        else {
                            head.grow = 1;
                        }
                        if (head.type === 'number') {
                            //head.width = (head.headerName.length * 11) + "px";
                            // head.selector = row => row[head.field] || '0';
                            head.cell = (row) =>
                                row['icon_' + head.field] ? (
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", }}><NumericFormat value={row[head.field]} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} decimalScale={2} />
                                        <div style={{
                                            marginLeft: "4px", marginTop: "2px", width: "10px", height: "10px", borderRadius: "5px", backgroundColor: valueIcon(row['icon_' + head.field]),
                                        }}></div></div>) :
                                    (<NumericFormat value={row[head.field]} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} decimalScale={2} />)

                        }
                        if (head.field === 'point') {
                            head.cell = (row) => row.point
                        }
                    });
                    customTable = (
                        <CustomTableCharts
                            headers={data.headers}
                            lines={data.lines}
                            tableTitle={title}
                            tooltipHelp={tooltip}
                            rowCount={data.lines.length}
                            key={"tablechart_" + id}
                        />);
                }
            }
        } else if (category === 1) {
            if (type === "area") {
                script = scriptNoTempAreaCharts(data);
            } else {
                script = scriptNoTempColumnCharts(data);
            }
        } else if (category === 3) {
            if (!data.test0)
                nodata = true;
            else
                script = scriptTempCharts(data, stacking);
        } else if (category === 4 || category === 7 || category === 8) {
            if (type === "tab" || type === "palmares") {
                if (isObjEmpty(data) === false && data.lines) {
                    data.lines.map((line) => {
                        line.id = uuid();
                    });
                    data.headers.map(head => {
                        //head.flex = (100/data.headers.length);
                        head.headerAlign = 'center';
                        head.name = head.headerName;
                        //head.selector = row => row[head.field] ? (head.type === 'number' ? Number(row[head.field]) : row[head.field]) : '';
                        head.selector = row => row[head.field] || '';
                        head.sortable = true;
                        head.wrap = true;
                        head.right = head.type === 'number' ? true : false
                        if (head.type === 'palmares') {
                            head.width = '107px';
                        }
                        else {
                            head.grow = 1;
                        }
                        if (head.type === 'number') {
                            //head.width = (head.headerName.length * 11) + "px";
                            // head.selector = row => row[head.field] || '0';
                            head.cell = (row) =>
                                row['icon_' + head.field] ? (
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", }}><NumericFormat value={row[head.field]} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} decimalScale={2} />
                                        <div style={{
                                            marginLeft: "4px", marginTop: "2px", width: "10px", height: "10px", borderRadius: "5px", backgroundColor: valueIcon(row['icon_' + head.field]),
                                        }}></div></div>) :
                                    (<NumericFormat value={row[head.field]} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} decimalScale={2} />)

                        }
                        if (head.field === 'group') {
                            head.cell = (row) =>
                                <AdvancedSearchContext.Consumer>
                                    {(({ setChartIdGroup, setSelectedNodesInfo, setOutofcontextclic }) => {
                                        return (
                                            <div
                                                onClick={() => {
                                                    setOutofcontextclic("" + row.groupid);
                                                    setChartIdGroup([row.groupid]);
                                                    setSelectedNodesInfo(row.group);
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                {row.group}
                                            </div>)
                                    })}
                                </AdvancedSearchContext.Consumer>
                        }
                    });
                    customTable = (
                        <CustomTableCharts
                            headers={data.headers}
                            lines={data.lines}
                            tableTitle={title}
                            tooltipHelp={tooltip}
                            rowCount={data.lines.length}
                            key={"tablechart_" + id}
                            category={category}
                        />);
                }
                else
                    nodata = true;
            }
        } else if (category === 6) {
            if (type === "dpe_energy" || type === "dpe_tertiary") {
                if (data.val) {
                    customDPE = (
                        <DPE
                            value={data.val} dpeTitle={title}
                            shadow={false} lang={'fr'}
                            tooltipHelp={tooltip}
                            key={"dpechart_" + id}
                        />);
                }
            } else if (type === "dpe_co2") {
                if (data.val) {
                    customGES = (
                        <GES
                            value={data.val} gesTitle={title}
                            shadow={false} lang={'fr'}
                            tooltipHelp={tooltip}
                            key={"geschart_" + id}
                        />);
                }
            }
        } else if (category === 9) {
            if (isObjEmpty(data) === false && data.title) {
                script = scriptTempHeatMapCharts(data, stacking);
            }
            else {
                nodata = true;
            }
        } else if (category === 10) {
            script = scriptTempBubbleCharts(data, stacking);
        } else if (category === 11) {
            script = scriptTempScatterCharts(data, stacking);
        }
        if (!nodata) {
            customChart = (<CustomHighCharts
                chartTitle={title} chartOptions={script} tooltipHelp={tooltip} key={"datachart_" + id} simplecard={simplecard}
            />);

            if (script) {
                displayChart.push(customChart);

            } else if (customTable !== null) {
                displayChart.push(customTable);
            }
            //dpe
            if (customDPE !== null) {
                displayChart.push(customDPE)

            } else if (customGES !== null) {
                displayChart.push(customGES)
            }
        }
        else {
            let NoData = (<CustomNoData chartTitle={title} />);
            //displayChart.push(NoData);
        }
    }
    return displayChart;
};